import { ReCaptchaInstance } from 'recaptcha-v3';
import { verifyAuth } from './auth';
import { getActionToken, RecaptchaActions } from '../helpers/recaptchaHelpers';

export const API_ENDPOINT = process.env.GATSBY_API_URL;

export const submitContactForm = async ({
  recaptchaInstance,
  data,
  nodeLocale,
  entryId,
  formType,
}: {
  recaptchaInstance: ReCaptchaInstance;
  data: any;
  nodeLocale: string;
  entryId: string;
  formType: 'pageContactForm' | 'sectionForm';
}) => {
  let JWT_TOKEN: string | undefined = undefined;
  try {
    JWT_TOKEN = await verifyAuth();
  } catch (error) {
    return {
      success: false,
      errors: {
        General: ['Unfortunately you are not authorized to submit this form'],
      },
    };
  }
  let recaptchaActionToken: string | undefined = undefined;
  try {
    recaptchaActionToken = await getActionToken(
      recaptchaInstance,
      RecaptchaActions.SubmitContactForm
    );
  } catch (error) {
    return {
      success: false,
      errors: {
        General: ['Could not verify your browser'],
      },
    };
  }

  const apiEndpoint =
    formType === 'sectionForm'
      ? `${API_ENDPOINT}/endpoint`
      : `${API_ENDPOINT}/contact`;

  const response = await fetch(`${apiEndpoint}/${entryId}`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${JWT_TOKEN!}`,
      'g-recaptcha-response': recaptchaActionToken!,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...data,
      nodeLocale
    }),
  });
  if (response.status === 200) {
    return { success: true };
  }
  const result = await response.json();
  if (result.status === 403) {
    if (Array.isArray(result.error)) {
      const errorMessages = (result.error as any[]).reduce<
        Record<string, string[]>
      >((acc, cv) => {
        acc[cv.name] = [cv.message];
        return acc;
      }, {});

      return {
        success: false,
        errors: {
          ...errorMessages,
        },
      };
    }
  } else if (result.status >= 500) {
    return {
      success: false,
      errors: {
        General: ['There was an issue submitting the form'],
        ServerError: ['Form submission unsuccessful please try again later.'],
      },
    };
  } else if (result.status !== 200) {
    return {
      success: false,
      errors: {
        General: ['There was an issue submitting the form'],
      },
    };
  }
  return { success: true };
};
